// extracted by mini-css-extract-plugin
module.exports = {"container":"TablePagination_container__ylC6L","paginationControls":"TablePagination_paginationControls__xyn0C"};